import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WeightLogPage = lazy(() => import("./WeightLogPage"));

const WeightLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WeightLogPage />
    </Suspense>
  );
};

export default WeightLogPageLazy;
